export default "__VITE_ASSET__7e6f1794__"